<template>
    <div>
        <Header class="text-center">
            <h2 class="margin-bottom-50">NextStep Hiring Solutions</h2>
            <a target="_blank" href="https://nextstephiring.com/">
                <img width="250" class="margin-bottom-50" src="\images\NextStep.png">
            </a>
            <p>
                Struggling to find the perfect candidate? Let us simplify the process for you!
            </p>
            <p>
                At NextStep, we go beyond traditional job postings. Our team actively searches, filters, and screens
                candidates to connect you with exceptional talent that meets your unique needs.
            </p>
        </Header>

        <div class="col-xl-8 col-lg-8 offset-xl-2 offset-lg-2">
            <section id="contact" class="margin-bottom-60">
                <h3 class="headline margin-top-15 margin-bottom-35">Leave your contact details below, and we’ll get in
                    touch to discuss your hiring goals.
                </h3>
                <Form :initialSubject="subject" :initialMessage="message" :initialTo="to" :initialCc="cc"></Form>
            </section>
        </div>
    </div>
</template>

<script>
import Header from '~/components/base/Header.vue';
import Form from '~/components/contact/Form.vue';

export default {
    components: {
        Header,
        Form
    },
    data() {
        return {
            message: "I’m interested in learning more about your recruiting services. Please provide additional information.",
            to: "diti.pn@macherusa.com",
            cc: "akiva@nextstephiring.com",
            subject: "NextStep Recruiting Services Inquiry"
        };
    },
    head() {
        const { path = "" } = this.$route;

        const metaTitle = "NextStep Recruiting | Macher Jobs";
        const metaDescription = "Looking for top talent? NextStep Recruiting is here to help you build your team with ease.";
        const canonical = process.env.baseUrl + path;

        return {
            title: metaTitle,
            link: [{ rel: "canonical", href: canonical }],
            meta: this.createMetaTags({
                description: metaDescription,
                title: metaTitle,
                canonical,
                socialTitle: metaTitle,
                socialDescription: metaDescription,
                siteName: "Macher Jobs",
                twitter: "@FrumJewishJobs",
            }),
        };
    }
};
</script>

<style lang="scss" scoped>
.text-center {
    text-align: center;
}
</style>
